<div
  class="title-section inner-container"
  [ngStyle]="{
    'font-family': content.font,
    'font-size.px': content.fontSize
  }"
  [innerHTML]="content.title | normalizeHtml"
></div>
